import React from 'react';
import styled from 'styled-components';

import DoubleSparkleIcon from 'components/icons/DoubleSparkleIcon';

interface AdviceSectionProps {
  advice: string;
}

export const AdviceSection = ({ advice }: AdviceSectionProps) => {
  return (
    <AdviceBox>
      <DoubleSparkleIcon />
      <AdviceText>{advice}</AdviceText>
    </AdviceBox>
  );
};

const AdviceBox = styled.div`
  margin-top: 54px;
  font-size: 14px;
  background-color: #f7f7f2;
  border-radius: 2px;
  border: 1px solid #d9d9d980;
  padding: 20px;
`;

const AdviceText = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
`;
